import { SecondaryButton } from 'ui/button';
import { isNull } from 'utils/tsHelpers';
import { useTranslation } from '../../../../../../../hooks/useTranslation';
import { useSelectedHyperlink } from '../../../hooks/useSelectedHyperlink';
import { useDisableHyperlink } from '../../hooks/useDisableHyperlink';

export const UnlinkButton = () => {
  const { t } = useTranslation();
  const selectedHyperlink = useSelectedHyperlink();
  const disableHyperlink = useDisableHyperlink();

  return !isNull(selectedHyperlink) ? (
    <SecondaryButton onClick={disableHyperlink} data-test="unlink-button">
      {t('contentPicker.textEditor.disableHyperlink')}
    </SecondaryButton>
  ) : (
    <></>
  );
};
